<div class="sidebar_block">
  <h5 class="sidebar_block_title">HARVEST TIME TRACKING</h5>
  <button a-button class="btn_secondary"
    (click)="onTogglePopUp()">
    <span class="time"></span>
    Track Time
  </button>
  <harvest-widget *ngIf="iFrameVisible" [task]="task" [board]="board" (close)="onTogglePopUp()"></harvest-widget>
</div>
